import { Component, Input, OnInit } from '@angular/core';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { MapsService } from 'app/modules/maps/maps.service';

@Component({
  selector: 'app-employee-popup',
  templateUrl: './employee-popup.component.html',
  styleUrls: ['./employee-popup.component.scss']
})
export class EmployeePopupComponent implements OnInit {
  @Input()data: any;
  constructor(
    private _localisationService: LocalisationService,
    private _mapService: MapsService
  ) { }

  createNewJob(data: any): void {
    const jobData = {
      module: 'EMPLOYEE',
      data: data
    };
    this._mapService.newJobDrawerToggler.next(jobData);
  }

  openEmployeePreview(data?: any): void {
    const previewData = {
      'uid' : data.user_uid,
      'module' : 'USER'
    };
    this._mapService.previewUid.next(previewData);
  }

  ngOnInit(): void {
    this._localisationService.setDefaultLanguage();
  }

}
